// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.identity, 
.datetime-interval,
.identity>.form-group,
.datetime-interval>.form-group {
	display: flex;
}
.datetime-interval input {
	width: fit-content;
}
.identity>.form-group,
.datetime-inverval>.form-group {
	width: 50%;
}
.identity .form-group:not(:first-child) {
	padding-left: 20px;
}
.datetime-inverval .form-group:not(:first-child) {
	padding-left: 20px;
}
.datetime-interval .form-group label {
	text-align: center;
}
.form-group label {
	width: fit-content;
	min-width: 80px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/BookingForm.css"],"names":[],"mappings":"AAAA;;;;CAIC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;;CAEC,UAAU;AACX;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,eAAe;AAChB","sourcesContent":[".identity, \n.datetime-interval,\n.identity>.form-group,\n.datetime-interval>.form-group {\n\tdisplay: flex;\n}\n.datetime-interval input {\n\twidth: fit-content;\n}\n.identity>.form-group,\n.datetime-inverval>.form-group {\n\twidth: 50%;\n}\n.identity .form-group:not(:first-child) {\n\tpadding-left: 20px;\n}\n.datetime-inverval .form-group:not(:first-child) {\n\tpadding-left: 20px;\n}\n.datetime-interval .form-group label {\n\ttext-align: center;\n}\n.form-group label {\n\twidth: fit-content;\n\tmin-width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
